const shouldSkipElement = (element) => {
	if (element.classList.contains('wp-block-spacer')) return true;
	if (element.tagName === 'SCRIPT') return true;
	if (element.tagName === 'STYLE') return true;
	if (element.tagName === 'NOSCRIPT') return true;
	if (element.tagName === 'LINK') return true;
	return false;
};

const animateElement = (el) => {
	const animClass = el.dataset.animation;
	if (el.dataset.childs === 'true') {
		let idx = 0;
		Array.from(el.children).forEach((child) => {
			if (shouldSkipElement(child)) return;
			const delay = (parseFloat(el.dataset.delay) * 0.1 || 0) + idx * 0.15;
			child.style.animationDelay = `${delay}s`;
			child.classList.remove('animate__hidden');
			child.classList.add('animate__animated');
			if (animClass) {
				child.classList.add(animClass);
			}
			idx++;
		});
	} else {
		const delay = parseFloat(el.dataset.delay) * 0.1 || 0;
		el.style.animationDelay = `${delay}s`;
		el.classList.remove('animate__hidden');
		el.classList.add('animate__animated');
		if (animClass) {
			el.classList.add(animClass);
		}
	}
};

const initAnimations = () => {
	const elements = Array.from(document.querySelectorAll('[data-animation]'));

	if (!elements.length) return;

	const animatedElements = new Set();

	elements.forEach((el) => {
		if (el.dataset.childs === 'true') {
			Array.from(el.children).forEach((child) => {
				if (shouldSkipElement(child)) return;
				child.classList.add('animate__hidden');
			});
		} else {
			el.classList.add('animate__hidden');
		}
	});

	const observer = new window.IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting && !animatedElements.has(entry.target)) {
					animatedElements.add(entry.target);
					animateElement(entry.target);
					observer.unobserve(entry.target);
				}
			});
		},
		{
			root: null,
			rootMargin: '0px',
			threshold: 0.1,
		}
	);

	elements.forEach((el) => {
		observer.observe(el);
	});
};

document.addEventListener('DOMContentLoaded', initAnimations);

document.addEventListener('swup:content:replace', initAnimations);
